var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('optional-feature-editor',{attrs:{"title":"引用","description":"引用対象かを指定します。"},model:{value:(_vm.editingSource),callback:function ($$v) {_vm.editingSource=$$v},expression:"editingSource"}})}
var staticRenderFns = []

export { render, staticRenderFns }